<template>
  <hm-container>
    <div class="flex flex-end flex-wrap" slot="header">
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择更新方式"
        v-model="searchConditions.tagUpdateTimeType"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in updateWayList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择运行状态"
        v-model="searchConditions.enabledState"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in runStatusList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择审批状态"
        v-model="searchConditions.auditState"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in auditStatusList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <!-- <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择创建方"
        v-model="searchConditions.createBy"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in createByList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select> -->
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择最后计算状态"
        v-model="searchConditions.calcStatus"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in finalCalcStatusList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <el-select
        style="width: 200px"
        size="small"
        clearable
        placeholder="请选择标签分类"
        v-model="searchConditions.tagType"
        class="mr10"
        filterable
      >
        <el-option
          v-for="(v, i) in tagClassificationList"
          :key="i"
          :label="v.name"
          :value="v.value"
        ></el-option>
      </el-select>
      <el-input
        size="small"
        class="mr10"
        v-model="searchConditions.tagName"
        placeholder="请输入标签名称"
      ></el-input>
      <el-input
        size="small"
        class="mr10"
        v-model="searchConditions.createBy"
        placeholder="请输入创建人员"
      ></el-input>
      <el-button size="small" type="primary" @click="paging(1)">查询</el-button>
    </div>

    <el-table
      stripe
      border
      ref="table"
      :data="list"
      style="width: 100%"
      size="small"
    >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
        :index="index => index + (currentPage - 1) * pageSize + 1"
      ></el-table-column>
      <el-table-column
        prop="tagName"
        label="标签名称"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="tagRemark"
        label="描述"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column label="更新方式" header-align="center" align="center">
        <template v-slot="scope">
          <span>{{ scope.row.tagUpdateTimeType }}</span>
        </template>
      </el-table-column>
      <el-table-column label="运行状态" header-align="center" align="center">
        <template v-slot="scope">
          <span class="success" v-if="scope.row.enabledState === 'yes'"
            >运行中</span
          >
          <span class="gray" v-else>未运行</span>
        </template>
      </el-table-column>
      <el-table-column label="审核状态" header-align="center" align="center">
        <template v-slot="scope">
          <span class="success" v-if="scope.row.auditState === 'yes'"
            >已审批</span
          >
          <span class="gray" v-else>待审批</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="tagName"
        label="创建方式"
        header-align="center"
        align="center"
      >
        <template v-slot="scope">
          <span>{{
            scope.row.createType === "multiAttr" ? "多属性创建" : "sql创建"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="createBy"
        label="创建人员"
        header-align="center"
        align="center"
      ></el-table-column>
      <el-table-column label="操作" header-align="center" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            class="blue"
            @click="toDetails(scope.row)"
          >
            查看详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
  </hm-container>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      searchConditions: {},
      updateWayList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "每小时更新",
          value: "hour"
        },
        {
          name: "每天更新",
          value: "day"
        },
        {
          name: "每周更新",
          value: "week"
        },
        {
          name: "每月更新",
          value: "month"
        },
        {
          name: "每年更新",
          value: "year"
        }
      ],
      runStatusList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "运行中",
          value: "yes"
        },
        {
          name: "未运行",
          value: "no"
        }
      ],
      auditStatusList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "不通过",
          value: "no"
        },
        {
          name: "已通过",
          value: "yes"
        },
        {
          name: "审批中",
          value: "auditing"
        }
      ],
      createByList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "平台",
          value: "platform"
        },
        {
          name: "商家",
          value: "merchant"
        }
      ],
      finalCalcStatusList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "计算成功",
          value: "success"
        },
        {
          name: "计算失败",
          value: "fail"
        },
        {
          name: "等待计算",
          value: "waitCalc"
        }
      ],
      tagClassificationList: [
        {
          name: "全部",
          value: null
        },
        {
          name: "用户标签",
          value: "user"
        },
        {
          name: "商品标签",
          value: "goods"
        }
      ],
      abNormalList: []
    };
  },
  created() {
    this.queryList();
  },
  mounted() {},
  methods: {
    async queryList() {
      const { result } = await this.$store.dispatch("queryTagList", {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        ...this.searchConditions
      });
      const { records, total } = result;
      records.forEach(v => {
        v.tagUpdateTimeType = this.updateWayList.find(
          o => o.value === v.tagUpdateTimeType
        ).name;
      });
      this.list = records;

      this.total = total;
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(pageSize) {
      this.currentPage = 1;
      this.pageSize = pageSize;
      this.queryList();
    },
    toDetails(row) {
      this.$router.push({
        name: "TagDetails",
        query: {
          id: row.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
